<template>
  <div class="project u-bg-white-off u-relative">
    <template v-if="loaded">
      <div class="project__banner u-box-16by9 u-box-9by16--sm">
        <app-image
          v-if="data.image && data.image.length && !$device.isMobile"
          :width="1920"
          class="u-wrapper-panel u-fit-cover"
          :id="data.image[0].id"
          :src="data.image[0].url"
        />
        <app-image
          v-if="data.image && data.image.length && $device.isMobile"
          :width="720"
          :height="1280"
          class="u-wrapper-panel u-fit-cover"
          :id="data.image[1] ? data.image[1].id : data.image[0].id"
          :src="data.image[1] ? data.image[1].url : data.image[0].url"
        />

        <div class="u-row u-pad-x-1of12 u-middle u-wrapper-panel">
          <div class="u-relative">
            <div class="u-white">
              <p v-for="tag in data.brightTags" :key="tag.title" class="u-marg-r-md u-inline-block u-w10of10--sm"> {{tag.title}} </p>
            </div>
            <p class="t-h3 u-marg-t-md u-white u-w7of10">
              {{data.description}}
            </p>
          </div>
        </div>
      </div>
      <strates :data="data.brightStrates" />
      <transition name="t-fader--fast">
        <app-popin-marketing @close="closePopin" v-if="isPopinScroll && !isPopinSeen" :data="data.popinMarketing[0]" />
      </transition>
    </template>
  </div>
</template>

<script>
import Strates from '@/components/strates/Strates'
import AppImage from '@/components/common/AppImage'
import AppPopinMarketing from '@/components/AppPopinMarketing'

export default {
  metaInfo () {
    return {
      link: [
        { rel: 'canonical', href: 'https://brig.ht/projects/' + this.$route.params.slug }
      ]
    }
  },

  components: {
    Strates,
    AppImage,
    AppPopinMarketing
  },

  computed: {
    data () {
      return this.$store.getters['data/project']
    },
    global () {
      return this.$store.getters['data/global']
    },
    loaded () {
      return this.$store.getters['data/loaded']
    },
    isPopinSeen () {
      if (!this.data.popinMarketing.length) { return true }

      return this.$store.getters['global/popinsSeen'].includes(this.data.popinMarketing[0].slug)
    }
  },

  data () {
    return {
      isPopinScroll: false
    }
  },

  created () {
    this.onInit()
  },

  mounted () {
    this.interval = this.setInterval(this.onResize, 1000)

    console.log(this.$store.getters['global/popinsSeen'])
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    onInit () {
      this.$store.dispatch('data/project', this.$route.params.slug)
      this.isPopinScroll = false
      this.pageHeight = 0
      this.onResize()
    },

    onResize () {
      this.pageHeight = this.$root.$el.offsetHeight || this.$device.height
    },

    onScroll (e) {
      if (!this.isPopinScroll && this.$device.scroll.top > this.pageHeight * .35) {
        this.isPopinScroll = true
      }
    },

    closePopin () {
      this.$store.dispatch('global/setPopinsSeen', this.data.popinMarketing[0].slug)
    }
  },

  watch: {
    $route () {
      this.onInit()
    }
  }
}
</script>


<style lang="stylus">
.project
  &__banner
    max-height 650px
</style>
